import { render, staticRenderFns } from "./ConfiguracaoApi.vue?vue&type=template&id=46179ce0"
import script from "./ConfiguracaoApi.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoApi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports